import { memo } from 'react';
import { Box, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';
import { PlayArrow as PlayArrowIcon } from '@mui/icons-material';

interface VersionDiffProps {
  desired: string;
  actual: string;
}

const VersionDiff = memo<VersionDiffProps>(({ desired, actual }) => (
  <Box sx={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: 1.5, my: 1 }}>
    <Box
      sx={{
        p: 1.25,
        border: 1,
        borderColor: 'warning.light',
        bgcolor: (theme) => alpha(theme.palette.warning.main, theme.palette.mode === 'dark' ? 0.15 : 0.08),
        borderRadius: 1,
      }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.6, fontSize: 10 }}>
        Desired (OpsPilot)
      </Typography>
      <Typography sx={{ fontFamily: 'monospace', fontSize: 14, fontWeight: 500 }}>{desired}</Typography>
    </Box>
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'text.disabled' }}>
      <PlayArrowIcon />
    </Box>
    <Box
      sx={{
        p: 1.25,
        border: 1,
        borderColor: 'success.light',
        bgcolor: (theme) => alpha(theme.palette.success.main, theme.palette.mode === 'dark' ? 0.15 : 0.08),
        borderRadius: 1,
      }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.6, fontSize: 10 }}>
        Actual (in AWS)
      </Typography>
      <Typography sx={{ fontFamily: 'monospace', fontSize: 14, fontWeight: 500 }}>{actual}</Typography>
    </Box>
  </Box>
));

VersionDiff.displayName = 'VersionDiff';
export default VersionDiff;
